module.exports = __webpack_public_path__ + "img/danwei_hy.ec051af3.png";